import { QueryResult } from "@apollo/react-common";
import { createContext } from "react";

const QueryResultContext = createContext<QueryResult>(null)

export default QueryResultContext;